export enum NotificationKeys {
  email = "email_notifications",
  push = "push_notifications",
  sms = "sms_notifications",
}

export const NOTIFICATION_VALUES = {
  [NotificationKeys.email]: 2,
  [NotificationKeys.sms]: 4,
  [NotificationKeys.push]: 8,
};

export enum SettingsKeys {
  notifications = "notifications",
  biometric_auth = "biometric_auth",
  auth2fa = "auth2fa",
  activitySyncEnabled = "activitySyncEnabled"
}

export enum BiometricValues {
  enabled = "enabled",
  disabled = "disabled",
}
